import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../utilz/i18n';
import OverChargeClaimsContent from '../../screens/Claims/OverCharge/OverChargeClaimsContent';
import OverChargeClaimsFilters from '../../screens/Claims/OverCharge/OverChargeClaimsFilters';
import OverChargeClaimsFooter from '../../screens/Claims/OverCharge/OverChargeClaimsFooter';
import OverChargeClaimsHeader from '../../screens/Claims/OverCharge/OverChargeClaimsHeader';
import WithFilter from '../../screens/common/WithFilter';

const OverChargeClaimsPage: FC = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <WithFilter
      filterElement={<OverChargeClaimsFilters />}
      contentElement={<OverChargeClaimsContent />}
      filterTitle={t('translation:default.fields.filter')}
      pageTitle={t('translation:claims.overchargeClaims')}
      footerContent={<OverChargeClaimsFooter />}
      headerContent={<OverChargeClaimsHeader />}
    />
  );
};

export default OverChargeClaimsPage;
